import { useGlobalContext } from "../../context/GlobalContext";
import Color from "../../utils/Colors";



export function useColors()
{
    let context = useGlobalContext();

    let darkTheme = context.Context!.GetTheme!() == 'dark';

    let palete = darkTheme ? Color.DarkThemePastelColors : Color.LightThemePastelColors;

    let getColors = (qtd : number) => palete.slice(0, qtd);

    return {palete, getColors};

}


export function useGrayColors()
{
    let context = useGlobalContext();

    let darkTheme = context.Context!.GetTheme!() == 'dark';

    let palete = darkTheme ? Color.DarkThemeGrayColors : Color.LightThemeGrayColors;

    let getColors = (qtd : number) => palete.slice(0, qtd);

    return {palete, getColors};

}
